import { Component, OnInit, ChangeDetectionStrategy, Input, ViewEncapsulation } from '@angular/core';
import { ToolEnum } from '../../models/tool.enum';
import { Select, Store } from '@ngxs/store';
import { EngineCameraState } from '../../state/camera/engine.camera.state';
import { Observable } from 'rxjs';
import { ZoomCamera, SetCamera, SetCameraMode } from '../../state/camera/engine.camera.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { CenterCameraOnVisible } from '../../state/engine.actions';
import { ViewLayout } from 'src/app/view/models/view-layout.enum';
import { SetCheckedNodes } from '../../state/nodes/engine.nodes.actions';
import { HistoryService } from 'src/app/history/history.service';
import { RemoveContextLabel } from 'src/app/story/state/labels/story.labels.actions';
import { transition, trigger, sequence, style, animate } from '@angular/animations';

@Component({
  selector: 'app-engine-camera-bar',
  templateUrl: './engine-camera-bar.component.html',
  styleUrls: ['./engine-camera-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('show', [
      transition(':enter', [
        sequence([
          style({ 
            height: '0'
          }),
          animate('125ms ease-in-out', style({ 
            height: '*'
          }))
        ])
      ]),
      transition(':leave', [
        sequence([
          animate('125ms 125ms ease-in-out', style({ 
            height: '0'
          }))
        ])
      ])
    ])
  ]
})
export class EngineCameraBarComponent implements OnInit {
  viewLayout = ViewLayout;
  toolEnum = ToolEnum;

  @Input()
  showNav = true;

  @Input()
  showZoom = true;

  @Input()
  showPan = true;

  @Input()
  showResetPosition = true;

  @Input()
  showResetScene = true;

  @Select(EngineCameraState.getPanMode)
  panMode$: Observable<string>;

  @Select(StoryChaptersState.getSelectedChapterModified)
  selectedChapterModified$: Observable<boolean>;

  expandNav = false;
 
  constructor(
    private store: Store,
    private historyService: HistoryService
  ) { }

  ngOnInit() {
  }

  setZoom(state: 'in' | 'out' | '') {
    let zoomValue = (state === '') ? 0 : 8;
    zoomValue = (state === 'in') ? -zoomValue : zoomValue;
    
    this.store.dispatch(new ZoomCamera(zoomValue));
  }

  returnToChapterCamera() {
    const chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
    this.store.dispatch(new SetCamera(chapter.camera.location));
  }

  resetChapter() {
    this.returnToChapterCamera();
    this.historyService.resetChapter();
    this.store.dispatch(new SetCheckedNodes([]));
    this.store.dispatch(new RemoveContextLabel());
  }

  centerCamera() {
    this.store.dispatch(new CenterCameraOnVisible());
  }

  togglePan() {
    const mode = this.store.selectSnapshot(EngineCameraState.getPanMode) === 'pan' ? 'rotate' : 'pan';
    this.store.dispatch(new SetCameraMode(mode));
  }

  toggleNav() {
    this.expandNav = !this.expandNav;
  }
}
